import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectCv } from '../../../slices/profile';
import ButtonCircle from '../../Common/ButtonCircle';
import { RadarChart } from '../../CommonComponents';
import InfoIcon from "@material-ui/icons/Info";
import CreateIcon from "@material-ui/icons/Create";
import GetAppIcon from "@material-ui/icons/GetApp";
import { closeDialog, openDialog } from '../../../slices/dialog';
import { Assessment } from '../../Dialog/Assessment';
import "./RadarChart.scss";
import MyBadge from '../../Common/Badge';
import { RadarChartExplanation } from '../../Dialog/RadarChartExplanation';
import { RadarChartFeedback } from '../../Dialog/RadarChartFeedback';
import { addStudentSoftSkills } from '../../../api/student/softSkills';
import { openAlert } from '../../../slices/alert';
import { storage } from '../../../firebase';
import { useTranslation } from 'react-i18next';
import { analyticsEvents, softSkillsDataset } from '../../../db/models/const';
import StudentOnboardingAssessment from '../../../pages/StudentPrivate/Onboarding/Assessment/main';

const StudentRadarChart = ({ topRef }) => {
    const cv = useSelector(selectCv);
    const softSkills = cv?.softSkills;
    const dispatch = useDispatch();
    const [highlight, setHighlight] = useState(true);
    const radarRef = useRef(null);
    const [assessmentId, setAssessmentId] = useState("");
    const { i18n, t } = useTranslation();

    useEffect(() => {
        setAssessmentId("onboarding_school_" + i18n.language.split("-")[0]);
    }, [i18n.language])

    const action = (res, assessmentId) => {
        const answerChoiceNumber = 10;
        addStudentSoftSkills(res, assessmentId, answerChoiceNumber).then(() => {
            dispatch(openAlert({ type: "success", message: t("alert_generic_update") }));
            dispatch(closeDialog());
            setHighlight(false);
        });
    }

    const afterAssessment = () => {
        dispatch(closeDialog());
        return;
    }

    const onButtonClick = () => {
        if (!softSkills) {
            dispatch(openDialog({
                Content: StudentOnboardingAssessment,
                title: "Assessment",
                props: {
                    assessmentId,
                    storeAnswers: true,
                    onFinish: afterAssessment
                },
                closable: true
            }));
        } else {
            dispatch(openDialog({
                Content: RadarChartExplanation,
                title: t("student_ssExplanation_title"),
                props: {},
                closable: true
            }));
        }
    }

    useEffect(() => {
        if (!softSkills)
            setHighlight(true);
        else
            setHighlight(false);
    }, [softSkills])

    const onFeedback = () => {
        dispatch(openDialog({
            Content: RadarChartFeedback,
            title: "Feedback",
            props: {},
            closable: true
        }));
    }

    const onDownloadEmoji = () => {
        const maxSoftValue = Math.max(...Object.values(softSkills));
        const maxSoftSkillTag = Object.entries(softSkills).find(e => e[1] === maxSoftValue)?.[0];
        const softSkill = softSkillsDataset[maxSoftSkillTag];

        if (!softSkill) return;

        storage.ref("emoji/" + softSkill.storageFileName).getDownloadURL().then(url => {
            window.open(url, '_blank', 'noopener');
        });
    }

    return (
        <div className="card studentRadar">
            <div className="card__header border">
                <h2>{t("student_profile_ss_label")}</h2>
                <div className="studentRadar__topActionButtons">
                    {!highlight && <ButtonCircle onClick={onButtonClick}><InfoIcon /></ButtonCircle>}
                    {highlight && <MyBadge badgeContent={""}><ButtonCircle
                        onClick={onButtonClick}><CreateIcon /></ButtonCircle></MyBadge>}
                    {!highlight && <ButtonCircle onClick={onDownloadEmoji}><GetAppIcon /></ButtonCircle>}
                </div>
            </div>
            <div className="card__content">
                <div ref={radarRef}>
                    <RadarChart softSkills={softSkills} onClick={onButtonClick} />
                    <div id="radar"></div>
                </div>
            </div>
            <p className="feedback" onClick={() => onFeedback()}>{t("student_profile_ss_feedback")}</p>
        </div>
    )
}

export default StudentRadarChart
